var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"login-form tw-bg-white tw-pt-24 tw-px-10"},[_c('PasswordResetForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }